// extracted by mini-css-extract-plugin
export default {"popoverContent":"NftEllipsisShadowButton_popoverContent__OhgiI"};